import React from "react";
import { useLanguage } from "../../Providers/LanguageContext";
import SignUpButton from "./SignUpButton";
import iMg1 from "../../images/1_3 USO GENERAL.png";
import iMg2 from "../../images/1_1 USO GENERAL.png";
import iMg3 from "../../images/1_2.png";
import iMg4 from "../../images/1_4 USO GENERAL.png";
import iMg5 from "../../images/ilustraciones soluciones industriales_empresas contables 3.png";
import iMg5en from "../../images/ilustraciones soluciones industriales_empresas contables 3 EN.png";
import iMg6 from "../../images/Bancos y el Sector Bancario_6-87.png";
import iMg7 from "../../images/Bancos y el Sector Bancario-88.png";
import bodyimage from "../../images/fondo.png";

import tick from "../../images/tick.png";
import { useNavigate } from "react-router-dom";
import SignUpButton2 from "./SignUpButton2";
import './IndustrySolution.css'
import circle from '../../images/Ellipse 17.png'
import laptop from '../../images/image 6.png'
import dollar from '../../images/image 5.png'
import trading from '../../images/image 4.png'
import file from '../../images/image 7.png'
import circle2 from '../../images/Ellipse 18.png'
import signup from '../../images/00 1.png'
import UserBanner from "./UserBanner";
const GeneralUse = () => {
  const { language, currentLanguage } = useLanguage();
  const navigate = useNavigate();
  const general = true;
  return (
    <>

      <section
        id="agriculture_sec"
        className="banking d-none"

        style={{ backgroundImage: `url('${bodyimage}')`, position: "relative", paddingBottom: "0" }}
      >
        <div className="container">
          <div className="agriculture_head" style={{ marginBottom: "0" }}>
            <h3 style={{ color: "#0e2537" }}>
              {language.fisi_key_benifits}
            </h3>
          </div>
          <div className="row mb-5">
            <div className="col-md-6 col-12">
              <div className="agriculture_headtext">
                <h5>
                  {language.general_app_platform}
                </h5>
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.financial_management}
                    </h4>
                    <p>
                      {language.fisi_provide_compre}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg2} className="img-fluid" alt="" />
              </div>
            </div>
          </div>



          <div className="row mb-5">
            <div className="col-md-5 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg3} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-md-7 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>{language.expence_tracking}</h4>
                    <p>
                      {language.fisi_users_track}
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div className="row mb-5">

            <div className="col-md-8 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.automated_report}
                    </h4>
                    <p>
                      {language.fisi_gen_details}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg1} className="img-fluid" alt="" />
              </div>
            </div>
          </div>



          <div className="row mb-5">
            <div className="col-md-4 col-12 m-auto">
              <div className="agriculture_img">
                <img src={iMg4} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-md-8 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.bill_management}
                    </h4>
                    <p>
                      {language.fisi_manage_bills}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-7 col-12">
              <div className="agriculture_headtext">
                <div className="tickpara">
                  <div className="tick">
                    <img src={tick}></img>
                  </div>
                  <div>
                    <h4 style={{ color: "#333333" }}>
                      {language.security}
                    </h4>
                    <p>
                      {language.fisi_secure_user}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-5 col-12 m-auto">
              <div className="agriculture_img">
                {
                  currentLanguage === 'spanish'
                    ?
                    <img src={iMg5} className="img-fluid" alt="" />
                    :
                    <img src={iMg5en} className="img-fluid" alt="" />
                }
                {/* <div
                  className="registrarAnddescargar"
                  style={{
                    transform: "translate(-50% , -50%)",
                    top: "44%",
                    left: "21%",
                    flexDirection: "column",
                  }}
                >
                  <button
                    className="registrar_Btn"
                    style={{
                      background:
                        " linear-gradient(to right, #18465d 1%,#0f283b 100%,#2989d8 100%)",
                      border: "0",
                      marginBottom: "20px",
                    }}
                    onClick={() => navigate('/login')}
                  >
                    {language.homeBannerBtn1}
                  </button>
                  <button className="descargar_Btn">{language.homeBannerBtn2}</button>
                </div> */}
                <SignUpButton2 />
              </div>
            </div>
          </div>


        </div>
      </section>

      <div className="general_user_wrapper">
   <UserBanner general={general}/>
<div className="general_user_management_all_content_wrapper">
 <div className="general_financial_management_Wrapper">
          <div className="circle_img_1">
            <img className="cirle_svg_1" src={circle} />
          </div>
          <div className="container-fluid financial_management_content_wrapper">
            <div className="financial_management_left">
              <h1> {language.financial_management}</h1>
              <p> {language.fisi_provide_compre}</p>
            </div>
            <div className="financial_management_right">
              <img src={laptop} />
            </div>
          </div>
        </div>



        <div className="general_financial_management_Wrapper" >

          <div className="container-fluid financial_management_content_wrapper">

            <div className="financial_management_right">
              <img src={dollar} />
            </div>


            <div className="financial_management_left">
              <h1>{language.expence_tracking}</h1>
              <p>{language.fisi_users_track}</p>
            </div>
          </div>
        </div>



        <div className="general_financial_management_Wrapper" style={{
          padding: '0px 0px'
        }}>
          <img className="cirle_svg_2" src={circle2} style={{
            width:'350px',
            height:'350px',
            position:"absolute",
            top:'0',
            right:'0'
          }}/>
          <div className="container-fluid financial_management_content_wrapper">




            <div className="financial_management_left">
              <h1> {language.automated_report}</h1>
              <p> {language.fisi_gen_details}</p>
            </div>



            <div className="financial_management_right" style={{
              zIndex:9
            }}>
              <img src={trading} />
            </div>


          </div>
        </div>



        <div className="general_financial_management_Wrapper" style={{
          padding: '0px 0px'
        }}>
        <img className="cirle_svg_3" src={circle2} style={{
          position:'absolute',
          bottom:'-100px',
          left:'50px',
          width:'300px',
          height:'300px'
        }}/>
          <div className="container-fluid financial_management_content_wrapper">



            <div className="financial_management_right">
              <img src={file} style={{
                width:'80%'
              }} />
            </div>
            <div className="financial_management_left">
              <h1> {language.bill_management}</h1>
              <p> {language.fisi_manage_bills} </p>
            </div>






          </div>
        </div>


           <div className="general_financial_management_Wrapper" style={{
          padding: '0px 0px'
        }}>
        <img className="cirle_svg_3" src={circle2} style={{
          position:'absolute',
          bottom:'-100px',
          left:'50px',
          width:'300px',
          height:'300px'
        }}/>
          <div className="container-fluid financial_management_content_wrapper">

  <div className="financial_management_left">
              <h1>  {language.security}</h1>
              <p>{language.fisi_users_track} </p>
            </div>

            <div className="financial_management_right">
              <img src={signup}  />
            </div>
          






          </div>
        </div>
</div>
       
      </div>
    </>
  );
};

export default GeneralUse;
